import { ConfirmationData } from "../../models/types/general-types";

export const confirmationMapper: ConfirmationData = {
  deletingBudget: {
    title: "deletingBudget",
    message: "Are you sure you want to delete the budget?",
    type: "warning",
  },

  usingWeakPassword: {
    title: "weakMasterPassword",
    message: "weakMasterPasswordDesc",
    type: "warning",
  },

  deletingAccountWithGeneratedMessage: {
    title: "deleteAccount",
    message: "$GENERATED$",
    type: "warning",
  },

  deletingAccount: {
    title: "deleteAccount",
    message: "deleteAccountConfirmMessageNoTransactions",
    type: "warning",
  },

  deletingEarnVersion: {
    title: "deletingEarnVersion",
    message: "deleteEarnVersionWarningMessage",
    type: "warning",
  },

  deletingTransaction: {
    title: "areYouSureToDeleteTransactions",
    message: "",
    type: "warning",
  },

  unlinkingTransaction: {
    title: "unlinkTransactionConfirmTitle",
    message: "unlinkTransactionConfirmMessage",
    type: "warning",
  },

  usingDefaultInstitution: {
    title: "fileNotBelongingInstitution",
    message: "",
    type: "warning",
  },

  givingFirstConsent: {
    title: "wouldYouLikeToMakeAFirstConsent",
    message: "",
    type: "info",
  },

  havingNoChanges: {
    title: "noChangesWereMade",
    message: "$GENERATED$",
    type: "warning",
  },

  updatingBalance: {
    title: "wouldYouLikeToUpdateYouBalance",
    message: "$GENERATED$",
    type: "warning",
  },

  deletingEstimate: {
    title: "areYouSureYouWannaDeleteThisEstimate",
    message: "",
    type: "warning",
    destructive: true,
  },

  deletingCategory: {
    title: "areYouSureYouWannaDeleteThisCategory",
    message: "",
    type: "warning",
  },

  renamingCategory: {
    title: "areYouSureYouWannaRenameThisCategory",
    message: "$GENERATED$",
    type: "warning",
  },

  deletingGroceryList: {
    title: "$GENERATED$",
    message: "$GENERATED$",
    type: "error",
    destructive: true,
    customizedButton: {
      yes: { text: "groceryDeleteListConfirmButton", class: null },
      no: { text: "cancel", class: null },
    },
  },

  archivingUntickedGroceryList: {
    title: "groceryArchiveThisListTitle",
    message: "$GENERATED$",
    type: "info",
    dismissible: true,
    customizedButton: {
      yes: { text: "groceryCopyToNewList", class: null },
      no: { text: "groceryArchiveAnyway", class: null },
    },
  },

  deletingClassification: {
    title: "areYouSureYouWannaDeleteThisClassification",
    message: "",
    type: "warning",
  },

  deletingInstitution: {
    title: "areYouSureYouWannaDeleteThisInstitution",
    message: "",
    type: "warning",
  },

  deletingSymbol: {
    title: "areYouSureYouWannaDeleteThisSymbol",
    message: "deleteSymbolConfirmMessage",
    type: "warning",
  },

  askingForEarlyAccess: {
    title: "wouldYouLikeToGetEarlyAccess",
    message: "stillInDevelopmentFeature",
    type: "info",
  },

  removingBasiqDataOfRevokedConsent: {
    title: "consentRevoked",
    message: "wouldYouLikeToDeleteRevokedConsentData",
    type: "warning",
  },

  askingForReConsentOfExpired: {
    title: "consentExpired",
    message: "wouldYouLikeToReConsentOfExpired",
    type: "warning",
  },

  askingForReConsentOfRevoked: {
    title: "consentRevoked",
    message: "wouldYouLikeToReConsentOfRevoked",
    type: "warning",
  },

  removingBasiqDataOfExpiredConsent: {
    title: "consentExpired",
    message: "wouldYouLikeToDeleteExpiredConsentData",
    type: "warning",
  },

  importError: {
    title: "importError",
    message: "importErrorDesc",
    type: "error",
  },

  logOutConfirmation: {
    title: "logOut",
    message: "logOutConfirmation",
    type: "warning",
  },

  turnOffBiometrics: {
    title: "turnOffBiometrics",
    message: "turnOffBiometricsConfirmation",
    type: "warning",
  },

  turnOffBiometricsOnOtherDevice: {
    title: "turnOffBiometrics",
    message: "turnOffBiometricsOnOtherDeviceConfirmation",
    type: "warning",
  },

  switchToFreePlan: {
    title: "switchToFreePlan",
    message: "switchToFreePlanConfirmation",
    type: "warning",
  },

  updateBalanceAutomatically: {
    title: "updateBalanceAutomatically",
    message: "$GENERATED$",
    type: "info",
  },

  deletingPaymentMethod: {
    title: "deletingPaymentMethod",
    message: "deletingPaymentMethodConfirmation",
    type: "warning",
  },

  autoCreatingBudget: {
    title: "autoCreateBudget",
    message: "autoCreatingBudgetMessage",
    type: "info",
  },

  removingPasswordHint: {
    title: "removePasswordHint",
    message: "removePasswordHintConfirmation",
    type: "info",
  },

  pluginGatheringData: {
    title: "Gathering your data",
    message: "We are gathering your data. We will let you know when ready to import.",
    type: "info",
    singleButton: true,
  },

  pluginReadyToImport: {
    title: "Data ready",
    message: "Your data is ready. You can import it now.",
    type: "info",
  },

  pluginSyncCompleted: {
    title: "Sync completed",
    message: "Your data has been imported.",
    type: "info",
    singleButton: true,
  },

  fiskilDataReadyPullNow: {
    title: "fiskilDataReadyPullNow",
    message: "fiskilDataReadyPullNowMessage",
    type: "info",
    customizedButton: {
      yes: { text: "pullDataNow", class: null },
      no: { text: "maybeLater", class: null },
    },
  },

  confirmingBundleSwitch: {
    title: "bundleConfirmation",
    message: "$GENERATED$",
    type: "info",
    mobileBottomSheet: true,
  },

  leavingCreateAccountFlow: {
    title: "leavingThisPage",
    message: "leavingCreateAccountFlowMessage",
    type: "warning",
    customizedButton: {
      yes: { text: "yesGoToPlugins", class: null },
      no: { text: "stayHere", class: null },
    },
  },

  deletingVaultDuplicates: {
    title: "deleteDuplicates",
    message: "$GENERATED$",
    type: "warning",
  },

  bulkDeleteUnusedVaultSources: {
    title: "bulkDeleteUnusedVaultSources",
    message: "$GENERATED$",
    type: "warning",
  },

  removeAllVaultDuplicatesForType: {
    title: "removeAllVaultDuplicatesForType",
    message: "$GENERATED$",
    type: "warning",
  },

  processTakingTooLongRefresh: {
    title: "processTakingTooLongRefresh",
    message: "processTakingTooLongRefreshMessage",
    type: "warning",
    singleButton: true,
    stayOpenForPostConfirmAction: true,
    customizedButton: {
      yes: { text: "refresh", class: null },
      no: { text: "no", class: null },
    },
  },

  discardingKeychainChanges: {
    title: "keychainUnsavedChanges",
    message: "keychainUnsavedChangesDesc",
    type: "warning",
  },

  // Slide-out dismissed (click-away / Escape) with edited input.
  discardingUnsavedChanges: {
    title: "discardUnsavedChanges",
    message: "discardUnsavedChangesDesc",
    type: "warning",
  },
};
